export type DownloadDeps = {
  readonly createObjectUrl: (_blob: Blob) => string;
  readonly revokeObjectUrl: (_url: string) => void;
  readonly createAnchor: () => HTMLAnchorElement;
};

const defaultDeps: DownloadDeps = {
  createObjectUrl: (blob) => URL.createObjectURL(blob),
  revokeObjectUrl: (url) => URL.revokeObjectURL(url),
  createAnchor: () => document.createElement("a"),
};

/**
 * 表示中の BPMN をファイルとして書き出す（閲覧中・編集中の両方）。
 *
 * 画面での保存・取り込みはコンテナ内（AWS では EFS）の process-models を更新する
 * だけで、リポジトリの process-models/ には反映されない。残したい変更はここで
 * 書き出してコミットする。編集中は 409（他の人の更新）のときの逃げ道にもなる。
 */
export function downloadBpmn(
  fileName: string,
  xml: string,
  deps: DownloadDeps = defaultDeps,
): void {
  let url: string | null = null;

  try {
    url = deps.createObjectUrl(new Blob([xml], { type: "application/xml" }));

    const anchor = deps.createAnchor();
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
  } catch {
    // 書き出しに失敗しても画面の内容は変わらない（利用者は再試行できる）
  } finally {
    if (url !== null) deps.revokeObjectUrl(url);
  }
}
